import { Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import lighthouse from "../assets/banner.jpg"

const AboutUsCard = () => {
    const { t } = useTranslation()
    
    return (
        <Row className="d-flex justify-content-center mt-5">
            <Col xs={12} sm={12} md={6} lg={6}>
                <Card className="bg-white p-0 mt-0" style={{border: 'none'}}>
                    <Card.Body className="p-3">
                        <div className="roomNameWrapper">
                            <Card.Text>
                                <span style={{color: '#666', whiteSpace: 'pre-wrap', fontWeight: '400'}}>{t('aboutString')}</span>
                            </Card.Text>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4}>
                <Card className="bg-white shadow-sm md p-0 mt-2" >
                    <Card.Img src={lighthouse} style={{height: '25rem', objectFit: 'cover'}} alt="AboutUsCardItemImage"/>
                </Card>
            </Col>
        </Row>
    )
}

export default AboutUsCard